import Back from '@@/core/components/shared/Back/Back'
import SizeForm from '@@/core/components/size/SizeChartForm/SizeChartForm'
import { BModal, BFormGroup, BFormInput, BFormFile } from "bootstrap-vue";

export default {
  name: 'SizeChartTypeModal',
  components: {
    Back,
    SizeForm,
    BModal, BFormGroup, BFormInput, BFormFile
  },
  props: {
    item: Object,
    mode: String
  },
  watch: {
    mode: {
      immediate: true,
      handler: function (newVal) {
        if (this.mode === 'create') {
          this.values = ['']
          this.name = ''
        }
      },
    },
    item: {
      immediate: true,
      handler: function (newVal) {
        if (!newVal) return;
        this.name = this.item.name
        this.values = this.item.values.map(val => val.name);
      },
    }
  },
  data() {
    return {
      name: '',
      image: '',
      url: 'admin/size_chart_types',
      disabled: false,
      values: ['']
    }
  },
  mounted() {

  },
  methods: {
    addValue(index) {
      this.values.splice(index + 1, 0, '');
    },
     onImageChange(event) {
    const file = event.target.files[0];
    if (!file) return;
    
    this.image = file; 
  },

  async submit() {
    this.disabled = true;
    try {
      const formData = new FormData();
      formData.append('name', this.name);
      
      this.values.forEach((val, index) => {
        formData.append(`values[${index}]`, val);
      });

      if (this.image) {
        formData.append('image', this.image);
      }
      if (this.mode === 'edit') {
        formData.append('_method', 'PUT');
      }

      const url = this.url + (this.mode === 'edit' ? '/' + this.item.id : '');
      
      const response = await this.$axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      this.$root.notify(response, 'success');
      this.$root.$emit('bv::hide::modal', 'modal-SizeChartType');
      this.$emit(this.mode, response.data, this.item._index);
    } catch (error) {
      this.$root.notify(error);
    }
    this.disabled = false;
  }
  }
}
